import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { InfoPagesHeaderContainer, InfoPagesHeaderTitle } from 'src/styles/infoPages';

interface InfoPagesHeaderProps {
  title: string;
}

const InfoPagesHeader: React.FC<InfoPagesHeaderProps> = ({ title }) => {
  const { t } = useTranslation();

  return (
    <InfoPagesHeaderContainer>
      <InfoPagesHeaderTitle>{t(`${title}`)}</InfoPagesHeaderTitle>
    </InfoPagesHeaderContainer>
  );
};

export default InfoPagesHeader;
